export default function PHP_fetch_row() {
  return (
    <div>
      <h1>PHP_fetch_row</h1>
    </div>
  );
}
